import { Pipe, PipeTransform, NgModule, SecurityContext } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Pipe({
  name: 'bypassHtmlSanitizer',
  standalone: false,
})
export class BypassHtmlSanitizerPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}
  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value)
  }
}

@NgModule({
  declarations: [BypassHtmlSanitizerPipe],
  imports: [],
  exports: [BypassHtmlSanitizerPipe],
})
export class SanitizeHtmlPipeModule {}
